import { render } from "./ParseyLogo.vue?vue&type=template&id=b6d88ee0"
import script from "./ParseyLogo.vue?vue&type=script&lang=js"
export * from "./ParseyLogo.vue?vue&type=script&lang=js"
script.render = render

export default script